'use strict';

const ItemView = require('my/ui/task/item');
const ReadMoreCollectionView = require('framework/ui/view/readmore-collection');

module.exports = ReadMoreCollectionView.extend({
    childView: ItemView,
    childViewOptions: function() {
        return {
            context: this.getOption('context'),
            PrimaryContextView: this.getOption('PrimaryContextView')
        }
    },
    tagName: 'ul',
    className: 'list'
});



// WEBPACK FOOTER //
// ./my/ui/task/list.js